module.exports = __webpack_public_path__ + "static/media/Profit.0aafe6de.svg";